module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "zan-tag",
    class: [_vm.type ? ("zan-tag--" + _vm.type) : '', {
      'is-plain': _vm.plain,
      'is-mark': _vm.mark
    }]
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0d7be282!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/tag/src/main.vue
// module id = 143
// module chunks = 0 2